module.exports = __webpack_public_path__ + "static/img/wl.6c97f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/newUserActivity0628/wl.png
// module id = EBi6
// module chunks = 0